module.exports = __webpack_public_path__ + "static/media/71eQFOlZUtL._AC_SL1500_.906ab142.jpg";